module.exports = __webpack_public_path__ + "img/liuyan.12fef9f0.png";